export const hasAccess = (currentUser, functionName, history, permission = 'R', redirect = true) => {
  // ('@@@ Has Access > Is Admin >> ', currentUser, functionName, history, permission, redirect)
  if (currentUser.IsAdmin && (window.location.href.indexOf('admin/') > -1)) {
    const userAccess = currentUser.Access.filter((access) => {
      return (permission === 'RW' ?
        (access.functionarea_name === functionName && access.permission === permission) : (access.functionarea_name === functionName || access.functionarea_name === `ADMN: ${functionName}`))
    })
    if (userAccess.length <= 0) {
      if (redirect) {
        history.push({ pathname: '/unauthorised' })
      }
      return false
    }
  }
  return true
}




// WEBPACK FOOTER //
// ./src/utils/hasAccess.js